import React, { useState } from 'react';
import OverviewContainer from '../../emission_savings/OverviewContainer';
import EmissionTrends from '../../../emissions/components/emission_trends/EmissionTrends';

const Impacts = props => {
    return(
        <>
        <EmissionTrends isMobile={props.isMobile}/>
        <>
        <br/>
        <OverviewContainer userData={props.userData} isMobile={props.isMobile}/>
        </>
        </>    
    );
}

export default Impacts;